export default __webpack_public_path__ + "static/media/unlock.4b5df50c.svg";